import React, { useState, useEffect, useCallback } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import Layout from "../components/layout";
import styles from "./getapp.module.css";

const APP_STORE = "AppStore";
const PLAY_STORE = "PlayStore";

const getStore = () => {
  if (isIOS) return APP_STORE;
  if (isAndroid) return PLAY_STORE;
  return null;
};

const STORES = {
  AppStore: "https://apps.apple.com/se/app/ohcleo/id1538135901?l=en",
  PlayStore: "https://play.google.com/store/apps/details?id=com.ohcleo.android",
};

const GetApp = () => {
  const [selectedRatingCard, setRatingCard] = useState(1);

  const getApp = (store, dnt = false) => {
    const url = STORES[store];

    if (!url) return;

    if (!dnt && typeof window !== "undefined") {
      if (window.fbq) {
        window.fbq("track", "ViewContent", { content_name: store });
      }
      if (window.gtag) {
        window.gtag("event", "select_content", { content_type: store });
      }
    }

    setTimeout(() => {
      window.location.href = url;
    }, 500);
  };

  const redirect = useCallback(() => {
    if (
      typeof window !== "undefined" &&
      window.location.search &&
      (window.location.search.indexOf("redirect") > -1 ||
        window.location.search.indexOf("go") > -1)
    ) {
      const store = getStore();
      getApp(store, true);
    }
  }, []);

  const reviews = [
    {
      rating: 5,
      text: "Very beautiful sexy and sensual... ",
      addText: "❤️❤️",
    },
    {
      rating: 5,
      text: "OMG you made me come thrice... More please ",
      addText: "🙇‍♀️",
    },
    {
      rating: 5,
      text:
        "Intelligent and engaging and instructive... Going to try her suggestions ",
      addText: "💪🏾",
    },
  ];

  useEffect(() => {
    redirect();
  }, [redirect]);

  useEffect(() => {
    const interval = setInterval(() => {
      setRatingCard(pv => (pv === reviews.length ? 1 : pv + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [reviews.length]);

  const containerHandler = () => {
    if (isIOS && isAndroid) {
      getApp(getStore());
    }
  };

  return (
    <Layout title="Get OhCleo App" hideNavigation darkBG>
      <div
        tabIndex="0"
        role="button"
        onClick={containerHandler}
        className={styles.container}
        style={{ backgroundImage: "url('/images/app_landing_page.png')}" }}
      >
        <div className={styles.photoHolder}>
          {/* <img src="/images/app_landing_page.png"/> */}
        </div>
        <div className={styles.bottom}>
          <div data-id={selectedRatingCard} className={styles.reviews}>
            {reviews.map(item => (
              <div key={item.text} className={styles.review}>
                <div>
                  <img src="/images/star.svg" alt="" />
                  &nbsp;
                  <img src="/images/star.svg" alt="" />
                  &nbsp;
                  <img src="/images/star.svg" alt="" />
                  &nbsp;
                  <img src="/images/star.svg" alt="" />
                  &nbsp;
                  <img src="/images/star.svg" alt="" />
                </div>
                <p>
                  &quot;{item.text}
                  <span>{item.addText}</span>&quot;
                </p>
              </div>
            ))}
          </div>
          <div className={styles.appImgs}>
            {isIOS && (
              <button type="button" onClick={() => getApp(APP_STORE)}>
                <img
                  src="/images/app_store.png"
                  alt="app store"
                  height="64px"
                />
              </button>
            )}
            {isAndroid && (
              <button type="button" onClick={() => getApp(PLAY_STORE)}>
                <img
                  src="/images/google_play.png"
                  alt="download on Google play"
                  height="64px"
                />
              </button>
            )}
          </div>

          {/* Desktop */}
          {!isIOS && !isAndroid && (
            <div className={styles.appImgs}>
              <button type="button" onClick={() => getApp(APP_STORE)}>
                <img
                  src="/images/app_store.png"
                  alt="app store"
                  height="64px"
                />
              </button>
              <button type="button" onClick={() => getApp(PLAY_STORE)}>
                <img
                  height="64px"
                  src="/images/google_play.png"
                  alt="download on Google play"
                />
              </button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default GetApp;
